import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Masthead/masthead.mjs';
import { css } from '@patternfly/react-styles';
export const MastheadToggle = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("span", Object.assign({ className: css(styles.mastheadToggle, className) }, props, { children: children })));
};
MastheadToggle.displayName = 'MastheadToggle';
//# sourceMappingURL=MastheadToggle.js.map